<script setup lang="ts">
import { useSearchStore } from "@/stores/search";
import FilterModal from "@/components/FilterModal/FilterModal.ce.vue";
import { submitTypePrice } from "@/globalConsts/submitTypes";
import { onBeforeMount, onUpdated } from "vue";
import { storeToRefs } from "pinia";

const store = useSearchStore();
const { initOptions } = store;
const { getFilterItems } = storeToRefs(store);

const emit = defineEmits<{
    (e: string): void;
}>();

onBeforeMount(async () => {
    await initOptions();
});

onUpdated(() => {
    emit("update");
});
</script>
<template>
    <ul class="[ c-filter-bar ]" role="scrollbar">
        <li
            class="[ c-filter-bar__item ]"
            v-for="filterItem in getFilterItems"
            :key="filterItem.uid"
        >
            <div
                v-if="
                    filterItem.categories.length > 0 ||
                    filterItem.submitType === submitTypePrice
                "
            >
                <filter-modal :filter="filterItem"> </filter-modal>
            </div>
        </li>
    </ul>
</template>
